module.exports = __webpack_public_path__ + "img/1049_help_title_en_85485d981.png";